/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BreedDto } from '../../models/breed-dto';

export interface BreedControllerUpdate$Params {
  id: string;
}

export function breedControllerUpdate(http: HttpClient, rootUrl: string, params: BreedControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BreedDto>> {
  const rb = new RequestBuilder(rootUrl, breedControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BreedDto>;
    })
  );
}

breedControllerUpdate.PATH = '/api/breed/{id}';
